import React from 'react'
import { Typography, Modal, Button, Icon, Row, Col } from 'antd'

const { Text, Title } = Typography
class ModalErrors extends React.PureComponent {

	error = () => {
		Modal.error({
		  title: ('เกิดข้อผิดพลาดบางรายการในขณะนี้ ขออภัยในความไม่สะดวก ลองใหม่อีกครั้ง'),
		  onOk() {
			window.location.reload();
		  },
		  onCancel() {
			window.location.reload();
		  },
		  okText:'ตกลง',
		  width:"650px",
		  footer:"null"
		});
	  }

	  closeModal = async () =>{
		window.location.reload();
	  }

	async componentDidMount() {
    }

	render() {
		const { title, subtitle } = this.props
		return (
			<>
				<Modal
					visible={true}
					closable={false}
					title={(
						<>
							<Row>
								<Col span={2}>
									<Icon type="close-circle" className="mr-2 color-red" style={{ fontSize: '25px'}} />
								</Col>
								<Col span={22}>
									<Text level={4}>
										เกิดข้อผิดพลาดบางรายการในขณะนี้
									</Text><br></br>
									<Text>
										ขออภัยในความไม่สะดวก
										<span className="color-red" onClick={ this.closeModal } style={{cursor:'pointer'}}> ลองใหม่อีกครั้ง <Icon type="reload" className="ml-1"/></span>
									</Text>
								</Col>
							</Row>
						</>
					)}
					onOk={
						() =>{
							window.location.reload();
						}
					}
					onCancel={
						() =>{
							window.location.reload();
						}
					}
					width={600}
					footer={null}>
				</Modal>
			</>
		)
	}
}

export default ModalErrors